import { useQuery } from '@tanstack/react-query';
import api from '../api/client';
import { TipoPagamento } from '../types';

export const useTiposPagamento = () => {
  return useQuery({
    queryKey: ['tipos-pagamento'],
    queryFn: async () => {
      const response = await api.get<TipoPagamento[]>('/tipos-pagamento');
      return response.data;
    },
    staleTime: 5 * 60_000,
  });
};
